import * as React from 'react';
import { Builder } from '@builder.io/react';

export interface TextComponentProps<TFontSize> {
	readonly text?: string;
	readonly forceFontSize?: TFontSize;
}

export interface FontSizeOption {
	readonly label: string;
	readonly value: string;
}

const register = <
	TProps extends TextComponentProps<TFontSizes[number]['value']>,
	TFontSizes extends readonly FontSizeOption[],
>(
	Component: React.FC<TProps>,
	options: {
		readonly fontSizes: TFontSizes;
		readonly defaultFontSize?: TFontSizes[number]['value'];
	},
): void => {
	Builder.registerComponent(Component, {
		name: 'Text',
		override: true,
		inputs: [
			{
				name: 'text',
				type: 'html',
				required: true,
				autoFocus: true,
				bubble: true,
				defaultValue: 'Enter some text...',
			},
			{
				name: 'forceFontSize',
				type: 'enum',
				enum: Array.from(options.fontSizes),
				defaultValue: options.defaultFontSize,
			},
		],
	});
};

export default register;
